import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
const analyticsAttributes = {
  componentName: 'breadcrumbsItem',
  packageName: "@atlaskit/breadcrumbs",
  packageVersion: "12.0.2"
};
const noop = __noop;
export default /*#__PURE__*/React.forwardRef(({
  hasOverflow = true,
  href = '#',
  onClick: onClickProvided = noop,
  analyticsContext,
  iconBefore,
  iconAfter,
  ...props
}, ref) => {
  const handleClicked = usePlatformLeafEventHandler({
    fn: onClickProvided,
    action: 'clicked',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  return /*#__PURE__*/React.createElement(Button, _extends({
    appearance: "subtle-link",
    spacing: "none",
    iconAfter: hasOverflow ? undefined : iconAfter,
    iconBefore: hasOverflow ? undefined : iconBefore,
    onClick: handleClicked,
    ref: ref,
    href: href
  }, props));
});